





export default
  name: 'RightBox'
